<template functional>
  <div
    :style="{
      width: `${props.imageWidth}px`,
      ...props.customImagWrappeerStyle
    }"
  >
    <div
      class="image"
      :style="{
        width: `${props.imageWidth}px`,
        height: `${props.imageWidth}px`,
        ...((props.customStyle && props.customStyle.goodImage) || {})
      }"
    >
      <component
        :is="injections.components.GoodImage"
        :img-url="props.imgUrl | ossImage(500, 500, 'contain') | ossHttpVersion"
        :width="`${props.imageWidth}px`"
        :height="`${props.imageWidth}px`"
        :fit="'cover'"
      />

      <component
        :is="injections.components.GoodImgTag"
        :sku-img="props.skuImg"
        :custom-imag-style="props.customStyle"
      />
    </div>
    <div
      v-if="props.bottomTag"
      class="bottom-tip"
      :style="{
        color: `${props.bottomTag.textColor}`,
        backgroundColor: `${props.bottomTag.backgroundColor}`
      }"
    >
      {{ props.bottomTag.tag }}
    </div>
  </div>
</template>

<script>
import GoodImgTag from './good-Img-tag.vue'
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  inject: {
    components: {
      default: {
        GoodImgTag,
        GoodImage
      }
    }
  },
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    imageWidth: {
      type: Number,
      default: 0
    },
    promoteTagPic: {
      type: Array,
      default: () => []
    },
    stockStatus: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    layoutType: {
      type: String,
      default: ''
    },
    billionTip: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    customImagWrappeerStyle: {
      type: Object,
      default: () => {}
    },
    skuImg: {
      type: Object,
      default: () => {}
    },
    bottomTag: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: rgba(255, 255, 255, 0.6);
}
.bottom-tip {
  position: relative;
  top: -0.16rem;

  padding-top: 0.2rem;
  padding-bottom: 0.04rem;

  border-radius: 0 0 0.16rem 0.16rem;

  text-align: center;

  @include text(0.2rem, #fff);
}
.image {
  position: relative;

  flex: none;

  .new-customer-tag {
    position: absolute;
    top: 0.04rem;
    left: 0.04rem;

    width: 1.04rem;
    height: 0.28rem;

    background-color: #f03100;
    border-radius: 0.08rem;

    font-size: 0.24rem;
    color: #fff;

    @include flex-row-center;
    &.double {
      top: 0.16rem;
      left: 0.16rem;

      width: 1.12rem;
      height: 0.32rem;
    }
  }

  .video-pic {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 0.72rem;
    height: 0.72rem;
  }
  .promote-tag-pic {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;

    width: 100%;
    height: 100%;
  }

  .goods-status {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);

    width: 1.44rem;
    padding: 0.08rem 0 0.08rem 0;

    background-color: rgba(0, 0, 0, 0.45);
    border-radius: 0.08rem;

    font-size: 0.24rem;
    text-align: center;
    color: #fff;
    box-sizing: border-box;
    @include text-overflow-ellipsis-multiple;
    .status-text {
      @include text-overflow-ellipsis-multiple;
    }
  }
  .billion-tip {
    position: absolute;
    bottom: 0.04rem;
    left: 0.08rem;

    padding: 0.06rem 0.08rem;

    background-image: linear-gradient(to right, #ff790b, #ff4636);

    border-radius: 0.08rem;

    @include text(0.24rem, #fff);
  }
  .left-upper-tag {
    position: absolute;
    top: 0.08rem;
    left: 0.08rem;

    width: auto;
    height: 0.3rem;
  }
}
</style>
